module.exports = __webpack_public_path__ + "media/sf_laugh_creature_04.ec864d6a.mp3";